(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ea-gemstone-filter-tools"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ea-gemstone-filter-search')) {
  customElements.define('ea-gemstone-filter-search', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.details = this.closest('details');
      if (!this.input || !this.details) return;
      this.onInput = event => { event.stopPropagation(); this.filterChoices(); };
      this.onKey = event => { if (event.key === 'Enter') event.preventDefault(); };
      this.input.addEventListener('input', this.onInput);
      this.input.addEventListener('keydown', this.onKey);
      this.observer = new MutationObserver(() => this.filterChoices());
      this.observer.observe(this.details, { childList: true, subtree: true });
      this.filterChoices();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.input?.removeEventListener('input', this.onInput);
      this.input?.removeEventListener('keydown', this.onKey);
    }
    filterChoices() {
      const term = this.input.value.toLocaleLowerCase().trim();
      let matches = 0;
      this.details.querySelectorAll('li').forEach(item => {
        const checkbox = item.querySelector('input[type="checkbox"]');
        if (!checkbox) return;
        const label = item.querySelector('.facet-checkbox__text-label')?.textContent || checkbox.value;
        const match = !term || label.toLocaleLowerCase().includes(term);
        item.toggleAttribute('data-ea-gem-hidden', !match);
        item.toggleAttribute('data-ea-gem-match', !!term && match);
        if (match) matches++;
      });
      this.querySelector('[role="status"]').hidden = matches > 0;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
